import Alpine from "alpinejs";
import { ajaxify } from "./Ajaxify.js";

const hash = window.location.hash.substring(1);

Alpine.data("sidemenu", (url) => ({
    init() {
        if (hash.endsWith(".menu") || hash.includes("sidemenu=1")) {
            url = hash;
        }
        const element = this.$el;
        const parent = element.parentElement;
        ajaxify({
            url,
            element,
            target: element,
            remove: false,
            replace: true,
            callback: () => {
                this.$nextTick(() => {
                    let buttonsToTrigger = [];
                    let hasActiveLink = false;
                    // Loop over disclsoure elements
                    for (const element of [...parent.querySelectorAll(".sidemenu-main[x-disclosure]")]) {
                        // Get button to trigger
                        const button = element.querySelector("button[x-disclosure\\:button]");
                        const isOpen = element.hasAttribute("default-open");
                        if (!button) {
                            // Break the loop, because the button is not found
                            break;
                        }

                        // We have an active link
                        if (element.querySelector("a[aria-current='page']")) {
                            hasActiveLink = true;
                            if (!isOpen) {
                                button.click();
                            }
                            break;
                        }

                        if (isOpen) {
                            // Add the element to the open elements to close
                            buttonsToTrigger.push(button);
                        }
                    }
                    if (hasActiveLink) {
                        // If we have an active link, we need to close the other elements
                        buttonsToTrigger.forEach((button) => {
                            button.click();
                        });
                    }
                });
            },
        });
    },
}));
